import styled from 'styled-components';

import { COLOR } from 'constants/color';

export const VideoModal = styled.div<{ width: number; height: number }>`
  .es-modal {
    width: ${({ width }) => width + 48}px;
    height: ${({ height }) => height + 118}px;
  }

  .es-modal-header {
    font-size: 22px;
    line-height: 30px;
    font-weight: 500;
    color: ${COLOR.surfaceNeutralBold['neutral-11']};
    padding: 16px 18px 0 24px;
    svg {
      width: 24px;
      height: 24px;
    }
    svg path {
      stroke: ${COLOR.surfaceNeutralBold['neutral-11']} !important;
    }
  }

  .es-modal-body {
    padding: 16px 24px 0 24px;
  }
`;
